<div class="container menu-print">
  <div class="row">
    <!-- Left Column -->
    <div class="col-md-6">
      @for (group of leftGroups; track group) {
        <h4 class="group-title">{{ group }}</h4>
        @for (item of groupedMenu[group]; track item) {
          <div class="menu-item">
            <span class="item-name">{{ item.itemName }}</span>
            <span class="item-price">₹{{ item.salePrice }}</span>
          </div>
        }
      }
    </div>

    <!-- Right Column -->
    <div class="col-md-6">
      @for (group of rightGroups; track group) {
        <h4 class="group-title">{{ group }}</h4>
        @for (item of groupedMenu[group]; track item) {
          <div class="menu-item">
            <span class="item-name">{{ item.itemName }}</span>
            <span class="item-price">₹{{ item.salePrice }}</span>
          </div>
        }
      }
    </div>
  </div>
</div>